// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul{font-size:13px;line-height:1.5em;margin:5px 0 15px;padding:0}ul li{list-style:none;position:relative;padding:0 0 0 20px}ul li:before{content:\"\";position:absolute;left:0;top:5px;width:10px;height:10px;background-color:#283e79;border-radius:50%;-moz-border-radius:50%;-webkit-eeborder-radius:50%}", ""]);
// Exports
module.exports = exports;
